import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { TextField, Typography } from '@mui/material';
import { Button } from '../../../components';

import { AquaLogo } from '@wave-engagement/wave-react';
import { fullyAuthenticateUser } from '../../../redux/actions/authActions';

const Login = () => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const onSubmit = (e) => {
    e.preventDefault();

    fullyAuthenticateUser(dispatch, email, password);
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '3em' }}>
        <img src={AquaLogo} alt='Wave Engagement Logo' style={{ width: '100%', maxWidth: '300px', objectFit: 'contain', marginTop: '3em' }} />
      </div>
      <Typography variant='h1' gutterBottom>Login</Typography>

      <form onSubmit={onSubmit}>
        {/* Email */}
        <TextField
          required
          label='Email'
          type='email'
          onChange={(e) => setEmail(e.target.value)}
          disabled={auth.isLoading}
          variant='filled'
          style={{
            width: '100%',
            marginBottom: '0.5em'
          }}>
        </TextField>

        {/* Password */}
        <TextField
          required
          label='Password'
          type='password'
          onChange={(e) => setPassword(e.target.value)}
          disabled={auth.isLoading}
          variant='filled'
          style={{
            width: '100%',
            marginBottom: '0.5em'
          }}>
        </TextField>

        {/* Submit */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button
            type='submit'
            style={{ width: '48%', marginTop: '1em' }}
            isLoading={auth.isLoading}>
            Submit
          </Button>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '.5em' }}>
          Need an account?&nbsp;<Link to='/auth/create-account'>Create one now.</Link>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '.5em' }}>
          Forgot your password?&nbsp;<Link to='/auth/forgot-password/request'>Reset it now.</Link>
        </div>

      </form>
    </div>
  );
}
export default Login;